import LegalLayout from './LegalLayout';

export default function Offer() {
  return (
    <LegalLayout title="Публичная оферта" updatedAt="24 апреля 2026 года">
      <p>
        Настоящий документ является официальным предложением (публичной офертой) сервиса
        Resstro&nbsp;SaaS (далее «Сервис», «мы»), облачной системы управления
        предприятием общественного питания, включающей административную панель, кассовое
        приложение и&nbsp;электронное меню для гостей.
      </p>
      <p>
        Акцептом настоящей оферты является регистрация в&nbsp;Сервисе либо оплата подписки.
        С&nbsp;момента акцепта между Заказчиком и&nbsp;Исполнителем считается заключённым
        договор на&nbsp;условиях настоящей оферты.
      </p>

      <h2>1. Стороны</h2>
      <ul>
        <li>
          <strong>Исполнитель:</strong> индивидуальный предприниматель Раджабов Рустам
          Эфлетдинович, ИНН&nbsp;051707862851, email:{' '}
          <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>, телефон:{' '}
          <a href="tel:+79894734322">+7&nbsp;989&nbsp;473-43-22</a>.
        </li>
        <li>
          <strong>Заказчик:</strong> юридическое лицо или индивидуальный предприниматель,
          присоединившийся к&nbsp;настоящей оферте.
        </li>
      </ul>

      <h2>2. Термины</h2>
      <ul>
        <li>
          <strong>Сервис</strong>: программное обеспечение Resstro&nbsp;SaaS,
          предоставляемое по&nbsp;модели «программное обеспечение как услуга».
        </li>
        <li>
          <strong>Подписка</strong>: срочное право использования Сервиса
          на&nbsp;условиях выбранного тарифа.
        </li>
        <li>
          <strong>Учётная запись</strong>: совокупность данных, идентифицирующих
          Заказчика и&nbsp;его заведение.
        </li>
        <li>
          <strong>Тарифы</strong>: перечень условий и&nbsp;стоимости использования
          Сервиса, опубликованный по&nbsp;адресу{' '}
          <a href="https://resstro.ru/#pricing">resstro.ru/#pricing</a>.
        </li>
      </ul>

      <h2>3. Предмет оферты</h2>
      <p>
        Исполнитель предоставляет Заказчику неисключительное, непередаваемое право
        использования Сервиса в&nbsp;объёме, предусмотренном выбранным тарифом.
        В&nbsp;состав услуги входит:
      </p>
      <ul>
        <li>доступ к&nbsp;административной панели для управления меню, сменами и&nbsp;отчётами;</li>
        <li>доступ к&nbsp;кассовому приложению (iPad, Android-планшет, веб-браузер);</li>
        <li>электронное меню для гостей с&nbsp;QR-привязкой к&nbsp;столикам;</li>
        <li>техническая поддержка по&nbsp;email и&nbsp;WhatsApp в&nbsp;рабочие часы.</li>
      </ul>

      <h2>4. Стоимость и&nbsp;порядок оплаты</h2>
      <p>
        Актуальная стоимость подписки указана в&nbsp;разделе{' '}
        <a href="https://resstro.ru/#pricing">«Тарифы»</a> на&nbsp;сайте Сервиса.
        Оплата производится через платёжный сервис ЮKassa (НКО «ЮMoney»)
        путём списания с&nbsp;привязанной банковской карты Заказчика либо
        по&nbsp;безналичному расчёту с&nbsp;юридическим лицом по&nbsp;счёту.
      </p>
      <p>
        Списание за&nbsp;следующий период производится автоматически в&nbsp;дату окончания
        оплаченного периода. Заказчик вправе отключить автоматическое продление
        в&nbsp;административной панели.
      </p>
      <p>
        Первые 3&nbsp;(три) календарных дня пользования предоставляются бесплатно.
        По&nbsp;окончании пробного периода производится первое списание, если Заказчик
        не&nbsp;отменил подписку.
      </p>

      <h2>5. Права и&nbsp;обязанности</h2>
      <h3>Исполнитель обязуется:</h3>
      <ul>
        <li>обеспечивать работоспособность Сервиса круглосуточно, кроме плановых работ;</li>
        <li>сохранять конфиденциальность данных Заказчика и&nbsp;его гостей в&nbsp;соответствии с&nbsp;
          <a href="/legal/privacy">Политикой конфиденциальности</a>;
        </li>
        <li>предупреждать о&nbsp;плановых работах не&nbsp;менее чем за&nbsp;24&nbsp;часа.</li>
      </ul>
      <h3>Заказчик обязуется:</h3>
      <ul>
        <li>использовать Сервис в&nbsp;рамках законодательства РФ, в&nbsp;том числе 54-ФЗ;</li>
        <li>не&nbsp;передавать учётные данные третьим лицам;</li>
        <li>своевременно оплачивать подписку.</li>
      </ul>

      <h2>6. Отказ от&nbsp;подписки и&nbsp;возврат средств</h2>
      <p>
        Заказчик вправе отказаться от&nbsp;подписки в&nbsp;любой момент через
        административную панель или письменное уведомление на&nbsp;
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>. Условия возврата
        средств описаны в&nbsp;<a href="/legal/return">Политике возврата</a>.
      </p>

      <h2>7. Ответственность сторон</h2>
      <p>
        Исполнитель не&nbsp;несёт ответственности за&nbsp;убытки Заказчика, возникшие
        вследствие неправильной эксплуатации Сервиса, использования сторонних
        интеграций без согласования или нарушения Заказчиком требований законодательства.
      </p>
      <p>
        Стороны освобождаются от&nbsp;ответственности за&nbsp;частичное или полное
        неисполнение обязательств по&nbsp;настоящей оферте, если оно явилось следствием
        обстоятельств непреодолимой силы.
      </p>

      <h2>8. Изменения оферты</h2>
      <p>
        Исполнитель вправе вносить изменения в&nbsp;настоящую оферту. Актуальная
        редакция всегда доступна по&nbsp;адресу{' '}
        <a href="https://resstro.ru/legal/offer">resstro.ru/legal/offer</a>.
        Продолжение использования Сервиса после изменения оферты означает
        согласие Заказчика с&nbsp;её&nbsp;новой редакцией.
      </p>

      <h2>9. Порядок разрешения споров</h2>
      <p>
        Споры разрешаются путём переговоров, а&nbsp;при недостижении согласия
        в&nbsp;Арбитражном суде Республики Дагестан в&nbsp;соответствии
        с&nbsp;законодательством Российской Федерации.
      </p>

      <h2>10. Реквизиты Исполнителя</h2>
      <ul>
        <li>Индивидуальный предприниматель Раджабов Рустам Эфлетдинович;</li>
        <li>ИНН&nbsp;051707862851;</li>
        <li>Email: <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>;</li>
        <li>Телефон / WhatsApp: <a href="tel:+79894734322">+7&nbsp;989&nbsp;473-43-22</a>.</li>
      </ul>
      <p>
        Закрывающие документы (счёт, акт), а&nbsp;также банковские реквизиты для
        безналичной оплаты предоставляются по&nbsp;запросу на&nbsp;email Исполнителя.
      </p>
    </LegalLayout>
  );
}
